<template>
    <div class="all">
        <div class="header">
            <van-row>
                <van-col span="8" class="left">
                    <img :src="$store.getters.userInfo.threePartyUserInfo.headimgurl"
                         v-if="$store.getters.userInfo&&$store.getters.userInfo.threePartyUserInfo.headimgurl">
                    <img :src="person" v-else>
                </van-col>

                <van-col span="15" class="right">
                    <template v-if="$store.getters.userInfo!=null&&$store.getters.userInfo.status==1">
                        <van-row style="font-size: 1.6rem">
                            <span>{{personData.traderName}} </span>
                            <div class="role" >
                                <div style="display: flex;justify-content:flex-end;">
                                    <div style="margin-right:1px"><img :src="huojian"></div>
                                    <div>{{personData.roleName}}</div>
                                </div>
                            </div>
                        </van-row>
                        <van-row style="font-size: 1.2rem">
                            <span>{{personData.storeName}}</span>
                        </van-row>
                        <van-row style="font-size: 1rem">
                            <span>ID：{{personData.traderId}} </span>
                        </van-row>

                    </template>

                    <template v-else>
                        <van-row>
                            <van-col span="6">
                                <router-link to="/login">
                                    登陆
                                </router-link>
                            </van-col>
                            <van-col span="2">/</van-col>
                            <van-col span="8">
                                <router-link to="/register">
                                    注册
                                </router-link>
                            </van-col>
                        </van-row>
                    </template>

                </van-col>
            </van-row>
        </div>


        <div class="content">
            <van-row>
                <van-col span="2">
                    <img :src="per01">
                </van-col>
                <van-col span="22">
                    <van-cell title="基本信息" size="large" is-link to="/user/detail/0"/>
                </van-col>
            </van-row>

            <van-row>
                <van-col span="2">
                    <img :src="per02">
                </van-col>
                <van-col span="22">
                    <van-cell title="收款信息" size="large" is-link to="/user/detail/1"/>
                </van-col>
            </van-row>
          <van-row>
                <van-col span="2">
                    <img :src="per05">
                </van-col>
                <van-col span="22">
                    <van-cell title="团队及设价" size="large" is-link to="/user/group"/>
                </van-col>
            </van-row>

          <van-row>
            <van-col span="2">
              <img :src="per07">
            </van-col>
            <van-col span="22">
              <van-cell title="分享邀请" size="large" is-link to="/main/myteam"/>
            </van-col>
          </van-row>

            <van-row v-if="personData.needRealNameAuth">
                <van-col span="2">
                    <img :src="per02">
                </van-col>
                <van-col span="22">
                    <van-cell title="实名认证" size="large" is-link to="/user/detail/3"/>
                </van-col>
            </van-row>

            <van-row v-if="personData.roleName!='店员'">
                <van-col span="2">
                    <img :src="per03">
                </van-col>
                <van-col span="22">
                    <van-cell title="邀请码" size="large" is-link to="/user/detail/2"/>
                </van-col>
            </van-row>

            <van-row>
                <van-col span="2">
                    <img :src="per04">
                </van-col>
                <van-col span="22">
                    <van-cell title="修改密码" size="large" is-link to="/upPassword?id=0"/>
                </van-col>
            </van-row>
        </div>

        <div class="bottom" v-if="$store.getters.userInfo!=null&&$store.getters.userInfo.status==1">
            <van-button @click="exit()" round size="large">退出此账号</van-button>
        </div>
    </div>
</template>

<script>
    import userAPI from '@/api/user'
    import person from '@/assets/images/head-user.png'
    import per01 from '@/assets/images/per-icon-01.png'
    import per02 from '@/assets/images/per-icon-02.png'
    import per03 from '@/assets/images/per-icon-03.png'
    import per04 from '@/assets/images/per-icon-04.png'
     import per05 from '@/assets/images/per-icon-05.png'
    import per07 from '@/assets/images/per-icon-07.png'
    import huojian from '@/assets/images/huojian.png'

    export default {
        data() {
            return {
                //新版本
                person: person,
                per01: per01,
                per02: per02,
                per03: per03,
                per04: per04,
                per05: per05,
                per07: per07,
                personData: {},
                huojian:huojian
            }
        },
        created() {
            if (this.$store.getters.userInfo != null && this.$store.getters.userInfo.status == 1) {
                this.getPerson();
            }
        },
        methods: {
            getPerson() {
                userAPI.show().then(result => {
                    this.personData = result.data;
                    this.$toast.clear()
                })
            },
            exit() {
                this.$store.dispatch('removeToken');
            }
        },
    }
</script>

<style lang="scss" scoped>

    .all {
        background-color: #fff;
    }

    .header {
        background: -webkit-linear-gradient(left top, coral, #ffbb5c); /* Safari 5.1 - 6.0 */
        background: -o-linear-gradient(bottom right, coral, #ffbb5c); /* Opera 11.1 - 12.0 */
        background: -moz-linear-gradient(bottom right, coral, #ffbb5c); /* Firefox 3.6 - 15 */
        background: linear-gradient(to bottom right, coral, #ffc987); /* 标准的语法 */
        margin: 0.5rem;
        border-radius: 0.5rem;
        padding: 2rem 0rem 3rem 0rem;

        color: #fff;
        a {
            color: #fff;
        }

        .role {
            background-color: coral;
            float: right;
            border-radius: 1rem;
            font-size: 1rem;
            color: #FFFFFF;
            padding: 0.25rem 0.5rem 0rem 0.5rem;
        }
        img {
            height: 1.3rem;
            width: 1.3rem;
        }

        .left {
            img {
                /*padding: 1rem;*/
                margin: 1rem;
                background-color: #FFFFFF;
                height: 5rem;
                width: 5rem;
                border-radius: 50%;
                left: 20%;
                top: 0%;
                position: relative;
                overflow: hidden;
                vertical-align: middle;
            }
        }
        .right {
            font-size: 1.4rem;
            .van-row {
                margin-top: 0.5rem;
                .van-col {
                    line-height: 5rem;
                }
            }

        }

    }

    .content {
        .van-row {
            padding: 0rem 0rem 0rem 1rem;
            border-bottom: 1px solid #f2f2f2;
            line-height: 4rem;
        }
        img {
            margin-top: 0.5rem;
            height: 2.5rem;
            width: 2.5rem;
        }
    }

    .showName {
        font-size: small;
        .van-row {
            margin-bottom: 0.3rem;
            margin-top: 0.2rem;
            background-color: #ee9900;
            font-weight: bolder;
        }
    }

    .bottom {
        margin: 2rem;
        .van-button {
            background: -webkit-linear-gradient(left top, coral, #ffbb5c); /* Safari 5.1 - 6.0 */
            background: -o-linear-gradient(bottom right, coral, #ffbb5c); /* Opera 11.1 - 12.0 */
            background: -moz-linear-gradient(bottom right, coral, #ffbb5c); /* Firefox 3.6 - 15 */
            background: linear-gradient(to bottom right, coral, #ffc987); /* 标准的语法 */
            color: #fff;
            font-weight: bolder;
        }

    }
</style>
